import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'initials-icon',
    template: '<span class="initials-icon__initials" [style.color]="color" [textContent]="name | initials"></span>',
    styleUrls: ['./initials-icon.component.less'],
})
export class InitialsIconComponent {
    @Input() name: string;
    @Input() color: string;
    @Input() size = 32;

    @HostBinding('style.backgroundColor') get backgroundColor() { return this.color; }
    @HostBinding('style.--icon-size') get iconSize() { return `${this.size}px`; }
    @HostBinding('style.--font-size') get fontSize() { return `${Math.ceil(this.size * 13 / 32)}px`; }

}
